import { render, staticRenderFns } from "./create-new-student.vue?vue&type=template&id=e0db129a&"
import script from "./create-new-student.vue?vue&type=script&lang=js&"
export * from "./create-new-student.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports